<template>
    <div class="fixed h-[70px] flex justify-center items-center top-0 left-0 right-0 bg-[#FFFFFF] z-[1]" style="box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05)">
        <img src="@crewlixSrc/assets/images/crewlix-logo.svg" />
    </div>
</template>